import useSWRImmutable from 'swr/immutable';
import request from '@/utils/request';

const fetcher = (url: string) =>
    request
        .post<number>(url)
        .then(res => res.data || 0)
        .catch(() => 0);

function useUnreadCount() {
    const { data, error, mutate } = useSWRImmutable('/api/message/count', fetcher);
    return { data, error, mutate };
}

export default useUnreadCount;
